export default "__VITE_ASSET__CqwOWw3D__"